import React, { Component } from 'react'

import './Switching.css'

/* Components */
import SwitchingView from './SwitchingView'

/**
 * Modules
 */
import { message } from 'antd';
import { getASwitchingFromChamp, updateASwitchingFromChamp } from '../../utils/confrontationsFunctions';
import html2canvas from 'html2canvas';

class Switching extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,

            switchingObject: '',
            switchingTempObject: '',
            switchingId: null,

            arrayOfCompetitors: [],

            studentSexo: '',
            studentFaixa: '',
            studentPeso: '',
            studentIdade: '',
            roundOf16Competitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            quarterFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            semiFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            finalCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }],
            champion: '',

            arrayOfTeams: [],
            arrayOfTeamsWithScore: [],
            arrayOfTeamsToSelect: [],

            scoreDialog: false,

            filterFaixa: '',
            filterPeso: '',
            filterIdade: '',
            filterEquipe: '',
            addStudentManuallyDialog: false,

            /* Array to create divs that draws the line between switching */
            arrayForLines01: [1, 2, 3, 4],
            arrayForLines02: [1, 2],
            arrayForLines03: [1],

            loading: true,
        }
    }

    componentDidMount = () => {
        this.setState({
            champObject: this.props.champObject,
            champId: this.props.champId,
            switchingId: this.props.switchingId
        })
        this.renderSwitching(this.props.switchingId, this.props.champObject, this.props.champId)
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            champObject: nextProps.champObject,
            champId: nextProps.champId,
            switchingId: nextProps.switchingId
        })
        this.renderSwitching(nextProps.switchingId, nextProps.champObject, nextProps.champId);
    }

    renderSwitching = async (id, champ, champId) => {
        this.setState({ loading: true });
        this.hideFilters();

        /* Get all competitors and teams */
        let localArray = JSON.parse(sessionStorage.getItem('switchingArrayOfTeams'));
        let localArrayOfCompetitors = JSON.parse(sessionStorage.getItem('switchingArrayOfCompetitors'));

        if (id > 300 && id < 309)
            localArrayOfCompetitors = JSON.parse(sessionStorage.getItem('switchingArrayOfChampions'));

        if (localArrayOfCompetitors && localArray) {
            this.setState({
                arrayOfCompetitors: localArrayOfCompetitors,
                arrayOfStudents: localArrayOfCompetitors,
                filteredArrayOfStudents: localArrayOfCompetitors,
                arrayOfTeamsToSelect: localArray,

                /* Clear all infos */
                studentSexo: '',
                studentFaixa: '',
                studentPeso: '',
                studentIdade: '',

                /* Clear all confrontations */
                roundOf16Competitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
                quarterFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
                semiFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
                finalCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }],
                champion: '',
            })
        }

        /* Get all confrontations and info */
        if (id && champId) {
            let switching = await getASwitchingFromChamp(champId, id.toString());
            if (switching) {
                /* Get confrontations */
                if (switching.roundOf16)
                    this.setState({ roundOf16Competitors: switching.roundOf16 })
                if (switching.quarterFinals)
                    this.setState({ quarterFinalsCompetitors: switching.quarterFinals })
                if (switching.semiFinals)
                    this.setState({ semiFinalsCompetitors: switching.semiFinals })
                if (switching.final) {
                    this.setState({ finalCompetitors: switching.final })
                    if (switching.final[0].hasWon && switching.final[0].hasWon)
                        this.setState({ champion: switching.final[0].nome })
                    else if (!switching.final[0].hasWon && switching.final[0].hasWon)
                        this.setState({ champion: switching.final[1].nome })
                }

                /* Get teams with score */
                if (switching.arrayOfTeams)
                    this.setState({ arrayOfTeamsWithScore: switching.arrayOfTeams })

                /* Get info */
                this.setState({
                    studentSexo: switching.sexo,
                    studentFaixa: switching.faixa,
                    studentPeso: switching.peso,
                    studentIdade: switching.idade,
                    switchingObject: switching,
                    loading: false,
                })
            } else {
                let localSwitching = {
                    studentSexo: '',
                    studentFaixa: '',
                    studentPeso: '',
                    studentIdade: '',
                    roundOf16: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
                    quarterFinals: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
                    semiFinals: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
                    final: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }],
                    champion: '',
                }
                this.setState({ switchingTempObject: localSwitching, loading: false })
            }
        }
    }

    /* Update confrontations | Em stand by conforme orientação do cliente */
    updateConfrontations = async () => {
        /* Clear all confrontations */
        this.setState({
            roundOf16Competitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            quarterFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            semiFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            finalCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }]
        })

        /* Get all confrontations */
        if (this.props.location.state.switchingId !== undefined && this.props.location.state.switchingId.toString() !== '') {
            let switching = await getASwitchingFromChamp(this.props.location.state.__key, this.props.location.state.switchingId.toString());
            if (switching) {

                /* Get confrontations */
                if (switching.roundOf16)
                    this.setState({ roundOf16Competitors: switching.roundOf16 })
                if (switching.quarterFinals)
                    this.setState({ quarterFinalsCompetitors: switching.quarterFinals })
                if (switching.semiFinals)
                    this.setState({ semiFinalsCompetitors: switching.semiFinals })
                if (switching.final) {
                    this.setState({ finalCompetitors: switching.final })
                    if (switching.final[0].hasWon)
                        this.setState({ champion: switching.final[0].nome })
                    else if (!switching.final[0].hasWon && switching.final[0].hasWon !== undefined)
                        this.setState({ champion: switching.final[1].nome })
                }

                /* Get teams with score */
                if (switching.arrayOfTeams !== undefined)
                    this.setState({ arrayOfTeamsWithScore: switching.arrayOfTeams })

                /* Get info */
                this.setState({
                    studentSexo: switching.sexo,
                    studentFaixa: switching.faixa,
                    studentPeso: switching.peso,
                    studentIdade: switching.idade,
                    switchingObject: switching
                })
            }

            return true;
        }
    }

    fieldSexoToFilter = (value) => {
        this.setState({
            studentSexo: value
        })
    }

    fieldFaixaToFilter = (value) => {
        this.setState({
            studentFaixa: value
        })
    }

    fieldPesoToFilter = (value) => {
        this.setState({
            studentPeso: value
        })
    }

    fieldIdadeToFilter = (value) => {
        this.setState({
            studentIdade: value
        })
    }

    /**
     * Methods to create switching based in the filter fields
     */
    createSwitching = (createAutomatically) => {

        let localArrayOfCompetitors = this.state.arrayOfCompetitors
        let localArrayOfCompetitorsFiltered = []

        /* Create array with the final result and a flag to know when another filter has alread choosed */
        let finalLocalArray = [], hasAnotherFilter = false

        /* Check if a filter of sexo was determined */
        if (this.state.studentSexo) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['sexo'] === this.state.studentSexo)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localArrayOfCompetitors) {
                    if (localArrayOfCompetitors[key]['sexo'] === this.state.studentSexo)
                        finalLocalArray.push(localArrayOfCompetitors[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of faixa was determined */
        if (this.state.studentFaixa) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['faixa'] === this.state.studentFaixa)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localArrayOfCompetitors) {
                    if (localArrayOfCompetitors[key]['faixa'] === this.state.studentFaixa)
                        finalLocalArray.push(localArrayOfCompetitors[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of peso was determined */
        if (this.state.studentPeso) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['peso'] === this.state.studentPeso)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localArrayOfCompetitors) {
                    if (localArrayOfCompetitors[key]['peso'] === this.state.studentPeso)
                        finalLocalArray.push(localArrayOfCompetitors[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of idade was determined */
        if (this.state.studentIdade) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['idade'] === this.state.studentIdade)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localArrayOfCompetitors) {
                    if (localArrayOfCompetitors[key]['idade'] === this.state.studentIdade)
                        finalLocalArray.push(localArrayOfCompetitors[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if hasn't filter was select */
        if (!createAutomatically) {
            if (!this.state.studentSexo && !this.state.studentPeso && !this.state.studentFaixa && !this.state.studentIdade) {
                finalLocalArray = localArrayOfCompetitors
            }

            if (hasAnotherFilter)
                localArrayOfCompetitorsFiltered = finalLocalArray
            else
                localArrayOfCompetitorsFiltered = this.state.arrayOfCompetitors
        }

        let localShuffledArray = this.shuffleArray(localArrayOfCompetitorsFiltered)

        /* create array of teams */
        let localArrayOfTeams = [], localArrayOfTeamsScored = []
        for (let i = 0; i < localShuffledArray.length; i++) {
            let isANewTeam = true
            for (let j = 0; j < i; j++) {
                if (localShuffledArray[j].equipe === localShuffledArray[i].equipe) {
                    isANewTeam = false
                    break
                }
            }
            if (isANewTeam) {
                localArrayOfTeams.push(localShuffledArray[i].equipe)
                localArrayOfTeamsScored.push({ team: localShuffledArray[i].equipe, score: 0 })
            }
        }
        this.setState({ arrayOfTeams: localArrayOfTeams })

        /* create array of competitors per team */
        let localArrayOfCompetitorsPerTeam = []
        let indexOfTeam = 0
        for (let j = 0; j < localShuffledArray.length; j++) {
            for (let i = 0; i < localShuffledArray.length; i++) {
                let isANewCompetitor = true
                for (let k = 0; k < localArrayOfCompetitorsPerTeam.length; k++) {
                    if (localShuffledArray[i].__key === localArrayOfCompetitorsPerTeam[k].__key) {
                        isANewCompetitor = false
                        break
                    }
                }
                if (isANewCompetitor) {
                    let wasAdded = false

                    while (!wasAdded) {

                        if (localShuffledArray[i].equipe === localArrayOfTeams[indexOfTeam]) {
                            localArrayOfCompetitorsPerTeam.push(localShuffledArray[i])
                            wasAdded = true
                        } else if (indexOfTeam !== localArrayOfTeams.length - 1) {
                            indexOfTeam++
                        } else {
                            indexOfTeam = 0
                        }

                    }

                    break
                }
            }
        }

        if (localArrayOfCompetitorsPerTeam.length !== localShuffledArray.length) {
            for (let j = 0; j < localShuffledArray.length; j++) {
                let localHasCompetitor = false
                for (let i = 0; i < localArrayOfCompetitorsPerTeam.length; i++) {
                    if (localArrayOfCompetitorsPerTeam[i].__key === localShuffledArray[j].__key) {
                        localHasCompetitor = true
                        break
                    }
                }
                if (!localHasCompetitor) {
                    localArrayOfCompetitorsPerTeam.push(localShuffledArray[j])
                    break
                }
            }
        }

        /* separete the 2 collumns of switching */
        let localCollumn = true
        for (let i = 0; i < localArrayOfCompetitorsPerTeam.length; i++) {
            localArrayOfCompetitorsPerTeam[i].colunaUm = localCollumn
            if (i % 2 !== 0)
                localCollumn = !localCollumn
        }

        /* push round of 16, quarter finals and infos in firebase
            /* First: create an object with the infos and clear confrontations */
        let localInfos = {
            sexo: this.state.studentSexo,
            faixa: this.state.studentFaixa,
            peso: this.state.studentPeso,
            idade: this.state.studentIdade,
            arrayOfTeams: localArrayOfTeamsScored,
            roundOf16: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            quarterFinals: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            semiFinals: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            final: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }],
            hideFilters: true,
            champion: '',
        }

        /* Second: define beginning of confrontations */
        // eslint-disable-next-line
        let localStage = ''
        if (localArrayOfCompetitorsPerTeam.length > 8) {
            localStage = 'roundOf16'
            for (let i = 0; i < localArrayOfCompetitorsPerTeam.length; i++) {
                localInfos.roundOf16[i] = localArrayOfCompetitorsPerTeam[i]

                /* Break loop if has more than 16 competitor */
                if (i === 15)
                    break
            }
        } else if (localArrayOfCompetitorsPerTeam.length <= 2) {
            localStage = 'final'
            for (let i = 0; i < localArrayOfCompetitorsPerTeam.length; i++) {
                localInfos.final[i] = localArrayOfCompetitorsPerTeam[i]
                if (i === 1)
                    localInfos.final[i].colunaUm = false
            }

            /* Check if there is only one competitor and declare him champion */
            if (localArrayOfCompetitorsPerTeam.length === 1) {
                localInfos.final[0].hasWon = true
            }
        } else if (localArrayOfCompetitorsPerTeam.length <= 4) {
            localStage = 'semiFinals'
            for (let i = 0; i < localArrayOfCompetitorsPerTeam.length; i++) {
                localInfos.semiFinals[i] = localArrayOfCompetitorsPerTeam[i]
            }
        } else {
            localStage = 'quarterFinals'
            for (let i = 0; i < localArrayOfCompetitorsPerTeam.length; i++) {
                localInfos.quarterFinals[i] = localArrayOfCompetitorsPerTeam[i]
            }
        }

        /* Third: push in firebase || Função em stand by conforme solicitação do cliente */
        /*
        firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('switching').doc(this.props.location.state.switchingId.toString())
        .set(localInfos)
        .then(() => {
            /* Update confrontations *
            this.updateConfrontations()
        })
    
            /* Fourth: send WO to quarter finals if some competitor is out of fit || Função em stand by conforme solicitação do cliente */
        /*
        for(let i = 0; i < localArrayOfCompetitorsPerTeam.length; i++){
            if(!localArrayOfCompetitorsPerTeam[i].apto){
                let localAddIndex = 1 
                if(i % 2 !== 0)
                    localAddIndex = -1
    
                this.chooseACompetitor(i+localAddIndex, i+localAddIndex, i, localStage, localArrayOfCompetitorsPerTeam[i+localAddIndex])
            }
        }
        */

        /* Update confrontations localy */
        this.setState({
            switchingTempObject: localInfos,
            roundOf16Competitors: localInfos.roundOf16,
            quarterFinalsCompetitors: localInfos.quarterFinals,
            semiFinalsCompetitors: localInfos.semiFinals,
            finalCompetitors: localInfos.final,
            champion: localInfos.champion
        })
    }

    /**
     * Methods to clear all confrontations of switching
     */
    clearSwitching = () => {
        let clearedArray = {
            roundOf16: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            quarterFinals: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            semiFinals: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            final: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }],
            arrayOfTeams: [],
            scoreboard: {}
        }

        /* Função em stand by conforme solicitação do cliente */
        /*
        firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('switching').doc(this.props.location.state.switchingId.toString())
        .update(clearedArray)
        .then(() => {
            /* Update confrontations *
            this.updateConfrontations()
        })
        */

        /* Clear the champion and the array of teams */
        this.setState({
            champion: '',
            arrayOfTeams: [],
            arrayOfTeamsWithScore: [],

            /* Clear all switching infos */
            switchingTempObject: clearedArray,
            roundOf16Competitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            quarterFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            semiFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            finalCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }],
            scoreboard: {}
        })
    }

    /* Shuffle an array in js */
    shuffleArray = (array) => {
        let currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    /**
     * Methods to choose a competitor or winner
     */
    chooseACompetitor = (index, keyWinner, keyLose, stage, competitor) => {
        /* Choose if competitor winner the confrontation */
        if (competitor.nome !== '')
            this.chooseAWinner(index, keyWinner, keyLose, stage, competitor)

        /* Choose a competitor manually */
        else {
            this.openAddStudentManuallyDialog(index, stage)
        }
    }

    /**
     * Methods to choose a winner
     */
    chooseAWinner = (index, keyWinner, keyLose, stage, competitor) => {
        /* Only choose a winner if there are a competitor to choose */
        if (competitor.nome !== '') {
            /* Find the next stage */
            let nextStage = ''
            if (stage === 'roundOf16')
                nextStage = 'quarterFinals'
            else if (stage === 'quarterFinals')
                nextStage = 'semiFinals'
            else if (stage === 'semiFinals')
                nextStage = 'final'

            /* Get and Set in a variable of the all switching infos */
            let localSwitching = this.state.switchingTempObject
            if (this.state.switchingTempObject === '')
                localSwitching = this.state.switchingObject

            /* Update the local winner */
            if (stage === 'final') {
                localSwitching[stage][keyWinner]['hasWon'] = true
                localSwitching[stage][keyWinner]['score'] = 9
                localSwitching['champion'] = localSwitching[stage][keyWinner]['nome']
            } else {
                localSwitching[stage][keyWinner]['hasWon'] = true
            }

            /* Update the local lose */
            if (stage === 'final') {
                localSwitching[stage][keyLose]['hasWon'] = false
                localSwitching[stage][keyLose]['score'] = 3
                localSwitching[stage][keyLose]['lostTo'] = competitor.__key
            } else {
                localSwitching[stage][keyLose]['hasWon'] = false
                localSwitching[stage][keyLose]['lostTo'] = competitor.__key
            }

            /* Send winner to the next stage */
            /* First: Create a competitor with the basic infos */
            let localCompetitor = {
                __key: competitor.__key,
                apto: competitor.apto,
                equipe: competitor.equipe,
                faixa: competitor.faixa,
                idade: competitor.idade,
                nome: competitor.nome,
                peso: competitor.peso,
                pesoQtd: competitor.pesoQtd,
                sexo: competitor.sexo,
                wasDeleted: competitor.wasDeleted
            }

            /* Second: Push competitor in next stage */
            let localIndexOfNextStage = index
            if (nextStage !== '') {
                if (nextStage === 'final') {
                    if (index === 0 || index === 1)
                        localIndexOfNextStage = 0
                    else
                        localIndexOfNextStage = 1
                } else {
                    if (index % 2 === 0) {
                        if (index === 0 || index === 8 || index === 6 || index === 14)
                            localIndexOfNextStage = ((localIndexOfNextStage + 2) / 2) - 1
                        else if (index === 2 || index === 10)
                            localIndexOfNextStage = ((localIndexOfNextStage + 2) / 2)
                        else
                            localIndexOfNextStage = (localIndexOfNextStage / 2) - 1
                    }
                    else {
                        if (index === 1 || index === 7 || index === 9 || index === 15)
                            localIndexOfNextStage = ((localIndexOfNextStage + 1) / 2) - 1
                        else if (index === 3 || index === 11)
                            localIndexOfNextStage = ((localIndexOfNextStage + 1) / 2)
                        else
                            localIndexOfNextStage = ((localIndexOfNextStage - 1) / 2) - 1
                    }
                }

                /* Update the local winner to next stage */
                localSwitching[nextStage][localIndexOfNextStage] = Object.assign(localSwitching[nextStage][localIndexOfNextStage], localCompetitor)

            }

            /* Update switching localy */
            new Promise((resolve, reject) => {
                resolve(
                    this.setState({
                        switchingTempObject: localSwitching,
                        roundOf16Competitors: localSwitching.roundOf16,
                        quarterFinalsCompetitors: localSwitching.quarterFinals,
                        semiFinalsCompetitors: localSwitching.semiFinals,
                        finalCompetitors: localSwitching.final,
                        champion: localSwitching.champion
                    })
                )
            })
                .then(() => {
                    /* Build score */
                    this.buildScore(competitor.__key)
                })
        }

    }

    /**
     * Methods to build score of teams and competitor
     */
    buildScore = (keyOfWinner) => {
        let localArrayOfTeamsScored = []

        /* Score competitors and teams */
        let localSwitching = this.state.switchingTempObject
        if (this.state.switchingTempObject === '')
            localSwitching = this.state.switchingObject

        /* Score third place */
        let localCompetitor, localArrayOfSemiFinals = []
        localSwitching['semiFinals'].forEach(competitor => {
            localCompetitor = competitor
            localCompetitor.score = 0
            if (competitor.lostTo === keyOfWinner) {
                localCompetitor.score = 1
            }
            localArrayOfSemiFinals.push(localCompetitor)
        })

        localSwitching['semiFinals'] = localArrayOfSemiFinals

        /* Get who won in final and semifinals and score them */
        localSwitching['final'].forEach(competitor => {
            localArrayOfTeamsScored.push({ team: competitor.equipe, score: competitor.score })
        })
        localSwitching['semiFinals'].forEach(competitor => {
            if (competitor.score || competitor.score !== 0)
                localArrayOfTeamsScored.push({ team: competitor.equipe, score: competitor.score })
        })

        /* Put score in array of team */
        let finalArrayOfTeamScored = []

        for (let j = 0; j < this.state.arrayOfTeamsWithScore.length; j++) {
            finalArrayOfTeamScored.push(this.state.arrayOfTeamsWithScore[j])
            let sumOfScore = 0
            for (let i = 0; i < localArrayOfTeamsScored.length; i++) {
                if (localArrayOfTeamsScored[i].team === this.state.arrayOfTeamsWithScore[j].team) {
                    sumOfScore += localArrayOfTeamsScored[i].score
                }
            }
            finalArrayOfTeamScored[j].score = sumOfScore
        }

        localSwitching['arrayOfTeams'] = finalArrayOfTeamScored

        this.setState({ switchingTempObject: localSwitching })
    }

    /**
     * Method to sort an array of objects
     */
    sortArrayOfTeams = (variable) => {
        let localArrayToSort = this.state.arrayOfTeamsWithScore
        new Promise((resolve, reject) => {
            resolve(this.setState({ variableToSort: variable }))
        })
            .then(() => {
                localArrayToSort.sort(this.sortStepByStep)
                this.setState({
                    arrayOfTeamsWithScore: localArrayToSort
                })
            })
    }

    sortArrayOfCompetitors = (variable) => {
        let localArrayToSort = this.state.finalCompetitors
        new Promise((resolve, reject) => {
            resolve(this.setState({ variableToSort: variable }))
        })
            .then(() => {
                localArrayToSort.sort(this.sortStepByStep)
                this.setState({
                    finalCompetitors: localArrayToSort
                })
            })
    }

    sortStepByStep = (a, b) => {
        if (a[this.state.variableToSort] < b[this.state.variableToSort])
            return 1;
        if (a[this.state.variableToSort] > b[this.state.variableToSort])
            return -1;
        return 0;
    }

    /**
     * Methods to open/close score dialog
     */
    openScoreDialog = () => {

        /* Classify array by score */
        this.sortArrayOfTeams('score')
        this.sortArrayOfCompetitors('score')

        this.setState({
            scoreDialog: true
        })
    }

    closeScoreDialog = () => {
        this.setState({
            scoreDialog: false
        })
    }

    /**
     * Methods to open/close student list to choose manually dialog
     */
    openAddStudentManuallyDialog = (index, stage) => {
        this.setState({
            addStudentManuallyDialog: true,
            indexOfStudentToAddManually: index,
            stageOfStudentToAddManually: stage
        })
    }

    closeAddStudentManuallyDialog = () => {
        this.setState({
            addStudentManuallyDialog: false,
            //filteredArrayOfStudents: this.state.arrayOfStudents
        })
    }

    /**
     * Methods to read student choosed manually and add in confrontation
     */
    searchStudent = (value) => {
        let localFilteredArray = this.state.arrayOfStudents

        /* Create array with the final result and a flag to know when another filter has alread choosed */
        let finalLocalArray = [], hasAnotherFilter = false

        /* Check if a filter of name was determined */
        if (value !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of faixa was determined */
        if (this.state.filterFaixa !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['faixa'] === this.state.filterFaixa)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['faixa'] === this.state.filterFaixa)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of peso was determined */
        if (this.state.filterPeso !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['peso'] === this.state.filterPeso)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['peso'] === this.state.filterPeso)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of idade was determined */
        if (this.state.filterIdade !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['idade'] === this.state.filterIdade)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['idade'] === this.state.filterIdade)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of equipe was determined */
        if (this.state.filterEquipe !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['equipe'] === this.state.filterEquipe)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['equipe'] === this.state.filterEquipe)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if hasn't filter was select */
        if (this.state.filterFaixa === '' && this.state.filterPeso === '' && this.state.filterIdade === '' && this.state.filterEquipe === '' && value === '') {
            finalLocalArray = localFilteredArray
        }

        this.setState({
            filteredArrayOfStudents: finalLocalArray
        })
    }

    chooseAFaixaFilter = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterFaixa: value
                })
            )
        })
            .then(() => {
                this.searchStudent(document.getElementById('searchInput').value)
            })
    }

    chooseAPesoFilter = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterPeso: value
                })
            )
        })
            .then(() => {
                this.searchStudent(document.getElementById('searchInput').value)
            })
    }

    chooseAIdadeFilter = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterIdade: value
                })
            )
        })
            .then(() => {
                this.searchStudent(document.getElementById('searchInput').value)
            })
    }

    chooseAEquipeFilter = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterEquipe: value
                })
            )
        })
            .then(() => {
                this.searchStudent(document.getElementById('searchInput').value)
            })
    }

    /* Put student in the selected index of switching */
    putStudentInSwitching = (competitor) => {

        /* Get and Set in a variable of the all switching infos */
        let localSwitching
        if (this.state.switchingObject !== '')
            localSwitching = this.state.switchingObject
        else
            localSwitching = this.state.switchingTempObject

        let localCompetitor = {
            __key: competitor.__key,
            apto: competitor.apto,
            equipe: competitor.equipe,
            faixa: competitor.faixa,
            idade: competitor.idade,
            nome: competitor.nome,
            peso: competitor.peso,
            pesoQtd: competitor.pesoQtd,
            sexo: competitor.sexo,
            wasDeleted: competitor.wasDeleted
        }

        localSwitching[this.state.stageOfStudentToAddManually][this.state.indexOfStudentToAddManually] = Object.assign(localSwitching[this.state.stageOfStudentToAddManually][this.state.indexOfStudentToAddManually], localCompetitor)

        /* Update switching localy */
        this.setState({
            switchingTempObject: localSwitching,
            roundOf16Competitors: localSwitching.roundOf16,
            quarterFinalsCompetitors: localSwitching.quarterFinals,
            semiFinalsCompetitors: localSwitching.semiFinals,
            finalCompetitors: localSwitching.final
        })

        /* Close dialog */
        this.closeAddStudentManuallyDialog()
    }

    /* Remove student from switching */
    clearCompetitor = (index, stage) => {
        let localArray = []
        if (stage === 'roundOf16')
            localArray = this.state.roundOf16Competitors
        if (stage === 'quarterFinals')
            localArray = this.state.quarterFinalsCompetitors
        if (stage === 'semiFinals')
            localArray = this.state.semiFinalsCompetitors
        if (stage === 'final')
            localArray = this.state.finalCompetitors

        for (let i = 0; i < localArray.length; i++) {
            if (i === index) {
                let localColunaUm = localArray[i].colunaUm
                localArray[i] = { nome: '', colunaUm: localColunaUm }
                break
            }
        }

        /* Get and Set in a variable of the all switching infos */
        let localSwitching
        if (this.state.switchingObject)
            localSwitching = this.state.switchingObject
        else
            localSwitching = this.state.switchingTempObject

        localSwitching[stage] = localArray

        /* Update switching localy */
        this.setState({
            switchingTempObject: localSwitching,
            roundOf16Competitors: localSwitching.roundOf16,
            quarterFinalsCompetitors: localSwitching.quarterFinals,
            semiFinalsCompetitors: localSwitching.semiFinals,
            finalCompetitors: localSwitching.final
        })
    }

    /* Save in database */
    saveSwitching = async () => {
        this.setState({ loadingSave: true })

        await updateASwitchingFromChamp(this.state.champId, this.state.switchingId.toString(), this.state.switchingTempObject);

        this.setState({ loadingSave: false });
        this.hideFilters();
        message.success('Chave salva com sucesso!');
    }

    /**
     * Methods to show/hide filters field
     */
    showFilters = () => {
        document.getElementById('switchingFilters').style.display = 'block'
        document.getElementById('switchingFiltersChoosen').style.display = 'none'
    }

    hideFilters = () => {
        if (document.getElementById('switchingFilters') && document.getElementById('switchingFiltersChoosen')) {
            document.getElementById('switchingFilters').style.display = 'none'
            document.getElementById('switchingFiltersChoosen').style.display = 'block'
        }
    }

    renderPdf = () => {

        html2canvas(document.getElementById("printAreaOfSwitching")).then(canvas => {
            var pri = document.getElementById("ifmcontentstoprint_switching").contentWindow;
            pri.document.open();
            pri.document.appendChild(canvas);
            pri.document.close();
            pri.focus();
            pri.print();
        });
    }

    render() {
        return (
            <SwitchingView
                loading={this.state.loading}
                studentFaixa={this.state.studentFaixa}
                studentSexo={this.state.studentSexo}
                studentPeso={this.state.studentPeso}
                studentIdade={this.state.studentIdade}
                loadingSave={this.state.loadingSave}
                champion={this.state.champion}
                scoreDialog={this.state.scoreDialog}
                addStudentManuallyDialog={this.state.addStudentManuallyDialog}
                filterPeso={this.state.filterPeso}
                filteredArrayOfStudents={this.state.filteredArrayOfStudents}
                switchingId={this.state.switchingId}
                roundOf16Competitors={this.state.roundOf16Competitors}
                arrayForLines01={this.state.arrayForLines01}
                quarterFinalsCompetitors={this.state.quarterFinalsCompetitors}
                arrayForLines02={this.state.arrayForLines02}
                semiFinalsCompetitors={this.state.semiFinalsCompetitors}
                arrayForLines03={this.state.arrayForLines03}
                finalCompetitors={this.state.finalCompetitors}
                arrayOfTeamsToSelect={this.state.arrayOfTeamsToSelect}
                arrayOfTeamsWithScore={this.state.arrayOfTeamsWithScore}

                showFilters={() => this.showFilters()}
                fieldSexoToFilter={e => this.fieldSexoToFilter(e)}
                fieldFaixaToFilter={e => this.fieldFaixaToFilter(e)}
                fieldPesoToFilter={e => this.fieldPesoToFilter(e)}
                fieldIdadeToFilter={e => this.fieldIdadeToFilter(e)}
                clearSwitching={() => this.clearSwitching()}
                createSwitching={e => this.createSwitching(e)}
                openScoreDialog={() => this.openScoreDialog()}
                saveSwitching={() => this.saveSwitching()}
                hideFilters={() => this.hideFilters()}
                closeScoreDialog={() => this.closeScoreDialog()}
                closeAddStudentManuallyDialog={() => this.closeAddStudentManuallyDialog()}
                chooseAFaixaFilter={e => this.chooseAFaixaFilter(e)}
                chooseAIdadeFilter={e => this.chooseAIdadeFilter(e)}
                chooseAEquipeFilter={e => this.chooseAEquipeFilter(e)}
                searchStudent={e => this.searchStudent(e)}
                putStudentInSwitching={e => this.putStudentInSwitching(e)}
                chooseACompetitor={(i1, i2, i3, r, c) => this.chooseACompetitor(i1, i2, i3, r, c)}
                clearCompetitor={(i, r) => this.clearCompetitor(i, r)}

                renderPdf={() => this.renderPdf()}
            />
        )
    }

}

export default Switching